<mat-form-field class="selected-number-dropdown no-underline no-hint">
  <mat-select panelClass="selected-number-popup"
              [value]="selectedMessagingNumber()"
              [compareWith]="comparePhoneNumber"
              (valueChange)="onPhoneNumberValueChange($event)"
              [hideSingleSelectionIndicator]="true">
    <mat-select-trigger>
      @if (selectedMessagingNumber()?.userName) {
        <span class="selected-number-name" fxLayout="row">
          <span>{{ selectedMessagingNumber()?.userName }}</span>
          @if (selectedMessagingNumber()?.assignedUsers && selectedMessagingNumber()?.assignedUsers.length > 1) {
            <app-explanation>
              <label>Messaging Assigned To:</label><br />
              @for (name of selectedMessagingNumber()?.assignedUsers; track name; let i = $index) {
                <span>
                  {{ name }}<br>
                </span>
              }
            </app-explanation>
          }
        </span>
      }
      <span class="selected-number light-text" [class.warning]="!selectedMessagingNumber()?.campaignId">
        @if (selectedMessagingNumber()?.campaignId) {
          <span>{{ selectedMessagingNumber()?.phoneNumber | phoneNumber }}</span>
        } @else {
          <app-explanation icon="priority_high" label="{{selectedMessagingNumber()?.phoneNumber | phoneNumber}}">
            <span>
              This phone number is not 10DLC registered and may be blocked from sending messages.
              <a class="btn-link" role="button"
                 (click)="openSupportWidget()">Please contact us to register this number</a>.
            </span>
          </app-explanation>
        }
      </span>
    </mat-select-trigger>
    @if (showNumbersFilter()) {
      <mat-button-toggle-group class="show-only-my-numbers" name="showOnlyMyNumbers"
                               [value]="viewNumbersFilter()"
                               (change)="onNumbersFilterChange($event.value)">
        <mat-button-toggle class="item" value="send">My Numbers</mat-button-toggle>
        <mat-button-toggle class="item" value="all">All Numbers</mat-button-toggle>
      </mat-button-toggle-group>
    }

    @if (hasSendNumbers()) {
      @if (showMyGroupLabel()) {
        <mat-optgroup label="My numbers" [style.color]="'#9e9e9e'">
          @for (option of filteredMessagingNumbers(); track option.phoneNumber; let i = $index) {
            @if (option.allowSend) {
              <mat-option [value]="option" style="line-height: 1; height: 4em" class="selected-number-popup">
                <span style="font-weight: 600;font-size: 16px;line-height: 20px;">
                  {{ option.userName }}
                </span>
                <span style="font-weight: normal; font-size: 13px; line-height: 16px; padding-left: 0; display: block; width: 100%; "
                      [matBadge]="option.badge"
                      [matBadgeHidden]="!option.badge || option.badge <= 0"
                      matBadgePosition="after"
                      matBadgeColor="warn">
                      {{ option.phoneNumber | phoneNumber }}
                </span>
              </mat-option>
            }
          }
        </mat-optgroup>
      } @else {
        @for (option of filteredMessagingNumbers(); track option.phoneNumber; let i = $index) {
          @if (option.allowSend) {
            <mat-option [value]="option" style="line-height: 1; height: 4em" class="selected-number-popup">
              <span style="font-weight: 600;font-size: 16px;line-height: 20px;">
                {{ option.userName }}
              </span>
              <span style="font-weight: normal; font-size: 13px; line-height: 16px; padding-left: 0; display: block; width: 100%; "
                    [matBadge]="option.badge"
                    [matBadgeHidden]="!option.badge || option.badge <= 0"
                    matBadgePosition="after"
                    matBadgeColor="warn">
                    {{ option.phoneNumber | phoneNumber }}
              </span>
            </mat-option>
          }
        }
      }
    }

    @if (hasOtherNumbers()) {
      <mat-optgroup label="Other numbers" [style.color]="'#9e9e9e'">
        @for (option of filteredMessagingNumbers(); track option.phoneNumber; let i = $index) {
          @if (!option.allowSend) {
            <mat-option [value]="option" style="line-height: 1; height: 4em" class="selected-number-popup">
              <span style="font-weight: 600;font-size: 16px;line-height: 20px;">
                {{ option.userName }}
              </span>
              <span style="font-weight: normal; font-size: 13px; line-height: 16px; padding-left: 0; display: block; width: 100%; "
                    [matBadge]="option.badge"
                    [matBadgeHidden]="!option.badge || option.badge <= 0"
                    matBadgePosition="after"
                    matBadgeColor="warn">
                    {{ option.phoneNumber | phoneNumber }}
              </span>
            </mat-option>
          }
        }
      </mat-optgroup>
    }
  </mat-select>
</mat-form-field>
